import * as React from "react";
import { useState } from "react";
import { customGetAPIWithToken } from "services/utils/CustomAPI";
import LoginImage from "../../../assets/img/brand/loginHalf.png";
import LoginLogo from "../../../assets/img/brand/organflow 2.0 logo.png";
import { themes, adminRoleName } from "services/constants";
import { useForm } from "react-hook-form";
import * as Mui from "@mui/material";
import { InputAdornment } from "@material-ui/core";
import {
  Mail,
  LockOutlined,
  Visibility,
  VisibilityOff,
  Phone,
  Info,
} from "@mui/icons-material";
import { showToast } from "services/utils/Status";
import { useSelector } from "react-redux";
import { userManagementError } from "services/constants/ErrorMessages";
import "./Login.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { TenantDetails } from "./TenantDetails";
import { getAccessBasedRoute } from "services/utils/accessedBasedRoute";
import { supportLabel } from "services/constants";
import { setCompanyList } from "services/Redux/userToken";

export const Login = () => {
  const domainUrl = useSelector((state) => state.tokenReducer.domain);
  const history = useHistory();
  const [showTenantDetails, setShowTenantDetails] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tenantDetails, setTenantDetails] = useState([]);
  const [groupButtonActiveTap, setGroupButtonActiveTap] = useState(
    localStorage.getItem("LoginTag")
      ? localStorage.getItem("LoginTag")
      : "Email",
  );
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: "",
      phoneno: "",
      password: "",
    },
  });

  const getTenantDetails = async (data) => {
    let url =
      groupButtonActiveTap === "Email"
        ? `${domainUrl}user_tenant/details/?email=${data?.email.toLowerCase()}`
        : `${domainUrl}user_tenant/details/?phone_number=${data.phoneno}`;
    const userResponse = await fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    });
    const resData = await userResponse.json();
    if (userResponse?.ok) {
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        loginInLocalEnvironment(resData, data);
      } else {
        setShowTenantDetails(true);
        setTenantDetails(resData);
      }
    } else {
      if (userResponse.status === 403) {
        showToast("error", "403 Forbidden. Clear your cache.");
      } else {
        showToast("error", resData?.error);
      }
    }
  };

  const loginInLocalEnvironment = async (resData, data) => {
    let filterRow = resData.filter((data) => {
      return (
        `https://${data.domain_name}/api/` === domainUrl ||
        `http://${data.domain_name}:8000/api/` === domainUrl
      );
    });
    if (filterRow.length !== 0) {
      let url =
        groupButtonActiveTap === "Email"
          ? `${domainUrl}login/email_verfication/?email=${data.email.toLowerCase()}`
          : `${domainUrl}phone_verfication/?phone_no=${data.phoneno}`;
      const emailResponse = await fetch(url, {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      });
      const emailReturnResponse = await emailResponse.json();
      if (
        emailResponse.status === 200 &&
        emailReturnResponse.user_status === "Active"
      ) {
        localStorage.clear();
        const userId = emailReturnResponse.user_id;
        const userResponse = await fetch(`${domainUrl}custom-token-auth/`, {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify({
            username: emailReturnResponse.emailuser.username,
            password: filterRow[0].tenant_password,
          }),
        });
        const userReturnResponse = await userResponse.json();
        if (userReturnResponse?.error) {
          showToast("error", userReturnResponse?.error);
        }
        if (userResponse.status === 200) {
          const userData = {
            id: userId,
            first_name: emailReturnResponse.emailuser.first_name,
            username: emailReturnResponse.emailuser.username,
            last_name: emailReturnResponse.emailuser.last_name,
            email: emailReturnResponse.emailuser.email,
            type: emailReturnResponse.type,
            phonenumber: emailReturnResponse?.type?.phonenumber,
            approver: emailReturnResponse.approver,
            teamlead: emailReturnResponse.teamlead,
            firmName: emailReturnResponse.firm_name,
            approver_id: emailReturnResponse.approver_id,
            image_url: emailReturnResponse.image_url,
            department_id: emailReturnResponse.department_id,
            department_name: emailReturnResponse.department_name,
            employee_id: emailReturnResponse.employee_id,
            designation: emailReturnResponse.designation,
          };
          await getProductAccess(userReturnResponse.token, userId);
          await getCurrentUserAccessibleCompany(
            userReturnResponse.token,
            userId,
          );
          localStorage.setItem("currentuser", JSON.stringify(userData));
          localStorage.setItem("token", userReturnResponse.token);
          localStorage.setItem(
            "sessionToken",
            userReturnResponse.session_token,
          );
          if (emailReturnResponse.type === adminRoleName) {
            getCompanyDetails(userReturnResponse.token, emailReturnResponse);
          } else {
            reDirectPath(emailReturnResponse);
          }
        }
      } else if (
        emailReturnResponse.exists === false ||
        emailResponse.status === 400
      ) {
        showToast("error", emailReturnResponse.error);
        setShowTenantDetails(false);
        setIsLoading(false);
      } else if (emailReturnResponse.user_status === "Inactive") {
        showToast("error", userManagementError.emailReturnResponseError);
        setShowTenantDetails(false);
        setIsLoading(false);
      }
    } else {
      showToast(
        "error",
        `This ${
          groupButtonActiveTap === "Email" ? data.email : data.phonenumber
        } user on ${domainUrl} has no links.`,
      );
    }
  };

  const reDirectPath = (emailReturnResponse) => {
    let accessibleProducts = JSON.parse(localStorage.getItem("productAccess"));
    let product_name = accessibleProducts
      ? emailReturnResponse.type === supportLabel
        ? supportLabel
        : accessibleProducts[0]?.product_name
      : "default";
    const accesbasedReroutePath = getAccessBasedRoute(product_name);
    window.location.href = accesbasedReroutePath;
  };

  const getCurrentUserAccessibleCompany = async (token, userId) => {
    const companyAccess = await customGetAPIWithToken(
      `${domainUrl}user-group/user/company/?user_id=${userId}`,
      token,
    );
    if (companyAccess.ok) {
      setCompanyList(JSON.stringify(companyAccess.responseDetails));
      localStorage.setItem(
        "companyAccess",
        JSON.stringify(companyAccess.responseDetails),
      );
      localStorage.setItem(
        "topbarCompanyId",
        companyAccess.responseDetails?.length !== 0
          ? companyAccess?.responseDetails[0]?.company_id
          : 99999,
      );
      localStorage.setItem(
        "topbarCompanyName",
        companyAccess.responseDetails?.length !== 0
          ? companyAccess?.responseDetails[0]?.company_name
          : "All Companies",
      );
    }
  };

  const onSubmit = async (data) => {
    let url =
      groupButtonActiveTap === "Email"
        ? `${domainUrl}login/email_verfication_public/?email=${data.email.toLowerCase()}`
        : `${domainUrl}login/email_verfication_public/?phonenumber=${data.phoneno}`;
    const emailResponse = await fetch(url, {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    });
    const emailReturnResponse = await emailResponse.json();
    if (emailResponse.ok) {
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname.startsWith("127.");

      function getCSRFToken() {
        return document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1];
      }

      let userResponse;

      if (!isLocalhost) {
        // Fetch CSRF token
        await fetch(`${domainUrl}csrf/`, { credentials: "include" });

        userResponse = await fetch(`${domainUrl}custom-token-auth-public/`, {
          method: "POST",
          credentials: "include", // Important for sending cookies
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": getCSRFToken(),
          },
          body: JSON.stringify({
            username: emailReturnResponse.username,
            password: data.password,
          }),
        });
      } else {
        userResponse = await fetch(`${domainUrl}custom-token-auth-public/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: emailReturnResponse.username,
            password: data.password,
          }),
        });
      }
      if (userResponse?.ok) {
        await getTenantDetails(data);
      } else {
        if (userResponse?.status === 403) {
          showToast("error", "403 Forbidden. Clear your cache.");
        } else {
          showToast("error", "Invalid Credentials");
        }
      }
    } else if (
      emailReturnResponse.exists === false ||
      emailResponse.status === 400
    ) {
      showToast("error", emailReturnResponse.error);
      setIsLoading(false);
    } else if (emailReturnResponse.user_status === "Inactive") {
      showToast("error", userManagementError.emailReturnResponseError);
      setIsLoading(false);
    } else if (emailResponse.status === 403) {
      showToast("error", "403 Forbidden. Clear your cache.");
    }
  };

  const getProductAccess = async (token, userId) => {
    try {
      const response = await fetch(
        `${domainUrl}login/available/products/?user_id=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        },
      );
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem("productAccess", JSON.stringify(data));
      } else {
        throw new Error(data.error);
      }
    } catch (error) {
      showToast(error.message);
    }
  };

  const getCompanyDetails = async (token, emailReturnResponse) => {
    try {
      const response = await fetch(`${domainUrl}company/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
      });
      const data = await response.json();
      if (response.ok) {
        if (data.length === 0) {
          localStorage.setItem("currentScreen", "Administration");
          localStorage.setItem("currentSubMenu", "Users");
          window.location.href = "/admin/administration/user";
        } else {
          reDirectPath(emailReturnResponse);
        }
      } else {
        throw new Error(data.error);
      }
    } catch (error) {
      showToast(error.message);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleKeyPress = (e) => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  return showTenantDetails ? (
    <TenantDetails
      setIsLoading={setIsLoading}
      groupButtonActiveTap={groupButtonActiveTap}
      tenantDetails={tenantDetails}
      setShowTenantDetails={setShowTenantDetails}
      setTenantDetails={setTenantDetails}
    />
  ) : (
    <React.Fragment>
      <Mui.Grid
        container
        style={{
          overflowY: "hidden",
          height: "100vh",
          justifyContent: "center",
        }}
      >
        <Mui.Grid item xs={0} sm={0} md={6} lg={6}>
          <Mui.Paper style={{ height: "100%" }}>
            <Mui.Box
              component="img"
              src={LoginImage}
              alt="Login"
              sx={{
                width: "100%",
                height: { xs: "0px", sm: "0px", md: "100%", lg: "100%" },
                objectFit: "cover",
              }}
            />
            <a href="https://stringconsultants.com/">
              <Mui.Box
                sx={{
                  position: "absolute",
                  left: "25%",
                  bottom: "0.2%",
                  transform: "translate(-50%, -50%)",
                  color: "white",
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                © 2024 String Consultants. All Rights Reserved
              </Mui.Box>
            </a>
          </Mui.Paper>
        </Mui.Grid>
        <Mui.Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          sx={{ padding: { xs: 1, sm: 1 } }}
        >
          <Mui.Paper style={{ height: "100%" }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Mui.Grid
                container
                justifyContent="flex-end"
                sx={{ paddingTop: 2, paddingRight: 2 }}
              >
                <img
                  src={LoginLogo}
                  alt="LoginLogo"
                  style={{ height: "22%", width: "22%" }}
                />
              </Mui.Grid>
              <Mui.Grid
                container
                spacing={2}
                direction="column"
                display="flex"
                alignItems="center"
              >
                <Mui.Grid
                  item
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  style={{ minHeight: "14vh" }}
                ></Mui.Grid>
                <Mui.Grid item>
                  <Mui.Typography
                    sx={{
                      fontWeight: 800,
                      fontSize: {
                        xs: "25px",
                        sm: "25px",
                        md: "38px",
                        lg: "38px",
                        xl: "38px",
                      },
                      paddingLeft: 6,
                    }}
                  >
                    Welcome to Organflow
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item xs={12}>
                  <Mui.ButtonGroup
                    size="large"
                    aria-label="Large button group"
                    sx={{ border: `1px solid ${themes.loginImage}` }}
                  >
                    <Mui.Button
                      variant={
                        groupButtonActiveTap === "Email"
                          ? "contained"
                          : "outlined"
                      }
                      onClick={() => {
                        reset();
                        setGroupButtonActiveTap("Email");
                        localStorage.setItem("LoginTag", "Email");
                      }}
                      sx={{
                        background:
                          groupButtonActiveTap === "Email"
                            ? themes.loginImage
                            : "outlined",
                        textTransform: "capitalize",
                        border: "none",
                        "&:hover": {
                          border: "none",
                          background:
                            groupButtonActiveTap === "Email"
                              ? themes.loginImage
                              : "outlined",
                        },
                        color:
                          groupButtonActiveTap === "Email"
                            ? themes.whiteColor
                            : themes.headLine,
                        width: { xs: 150, sm: 150, md: 203, lg: 203, xl: 203 },
                      }}
                    >
                      Email
                    </Mui.Button>
                    <Mui.Button
                      variant={
                        groupButtonActiveTap === "PhoneNo"
                          ? "contained"
                          : "outlined"
                      }
                      onClick={() => {
                        reset();
                        setGroupButtonActiveTap("PhoneNo");
                        localStorage.setItem("LoginTag", "PhoneNo");
                      }}
                      sx={{
                        background:
                          groupButtonActiveTap === "PhoneNo"
                            ? themes.loginImage
                            : "outlined",
                        textTransform: "capitalize",
                        border: "none",
                        "&:hover": {
                          border: "none",
                          background:
                            groupButtonActiveTap === "PhoneNo"
                              ? themes.loginImage
                              : "outlined",
                        },
                        color:
                          groupButtonActiveTap === "Email"
                            ? themes.headLine
                            : themes.whiteColor,
                        width: { xs: 150, sm: 150, md: 203, lg: 203, xl: 203 },
                      }}
                    >
                      Phone No
                    </Mui.Button>
                  </Mui.ButtonGroup>
                </Mui.Grid>
                <Mui.Grid item xs={12} sx={{ marginTop: 2 }}>
                  {groupButtonActiveTap === "Email" ? (
                    <React.Fragment>
                      <Mui.Typography
                        sx={{ fontSize: 20, paddingRight: 43, fontWeight: 600 }}
                      >
                        Email
                      </Mui.Typography>
                      <Mui.TextField
                        sx={{
                          minWidth: {
                            xs: 360,
                            sm: 400,
                            md: 400,
                            lg: 407,
                            xl: 407,
                          },
                        }}
                        size="medium"
                        type="text"
                        placeholder="Enter e-mail"
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address",
                          },
                        })}
                        error={errors.email}
                        helperText={errors.email?.message}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Mui.Badge color="secondary" badgeContent={0}>
                                <Mail color="primary" />
                              </Mui.Badge>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <Mui.Typography
                        sx={{ fontSize: 20, paddingRight: 35, fontWeight: 600 }}
                      >
                        Phone No
                      </Mui.Typography>
                      <Mui.TextField
                        sx={{
                          minWidth: {
                            xs: 360,
                            sm: 400,
                            md: 400,
                            lg: 407,
                            xl: 407,
                          },
                        }}
                        size="medium"
                        type="text"
                        placeholder="Enter phone number"
                        {...register("phoneno", {
                          required:
                            groupButtonActiveTap === "Email"
                              ? false
                              : "Phone No is required",
                          minLength: {
                            value: 10,
                            message: "Minimum length is 10 digits",
                          },
                          maxLength: {
                            value: 15,
                            message: "Maximum length is 15 digits",
                          },
                        })}
                        error={errors?.phoneno}
                        helperText={errors?.phoneno?.message}
                        onKeyPress={handleKeyPress}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Mui.Badge color="secondary" badgeContent={0}>
                                <Phone color="primary" />
                              </Mui.Badge>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </React.Fragment>
                  )}
                  <Mui.Grid item xs={12} sx={{ marginTop: 2 }}>
                    <Mui.Typography
                      sx={{ fontSize: 20, paddingRight: 38, fontWeight: 600 }}
                    >
                      Password{" "}
                    </Mui.Typography>
                    <Mui.TextField
                      sx={{
                        minWidth: {
                          xs: 360,
                          sm: 400,
                          md: 400,
                          lg: 407,
                          xl: 407,
                        },
                      }}
                      size="medium"
                      placeholder="Please enter password"
                      type={showPassword ? "text" : "password"}
                      {...register("password", {
                        required: "Password is required",
                      })}
                      error={Boolean(errors.password)}
                      helperText={errors.password?.message}
                      InputProps={{
                        autoComplete: "current-password",
                        startAdornment: (
                          <InputAdornment position="start">
                            <Mui.Badge color="primary" badgeContent={0}>
                              <LockOutlined color="primary" />
                            </Mui.Badge>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <Mui.Badge color="primary" badgeContent={0}>
                              <Mui.IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </Mui.IconButton>
                            </Mui.Badge>
                          </InputAdornment>
                        ),
                      }}
                      onAnimationStart={(e) => {
                        if (e.animationName === "onAutoFillStart") {
                          const val = e.target.value;
                          setValue("password", val, { shouldValidate: true });
                        }
                      }}
                    />
                  </Mui.Grid>
                  <Mui.Grid
                    item
                    xs={12}
                    sx={{
                      marginTop: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      paddingRight: { xs: 4, sm: 2 },
                    }}
                  >
                    <Mui.Typography
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/auth/send/otp");
                        localStorage.setItem(
                          "PasswordHandling",
                          "ForgotPassword",
                        );
                      }}
                      fontSize={15}
                      style={{ fontWeight: "bold" }}
                    >
                      Forgot Password?
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid
                    item
                    xs={12}
                    sx={{
                      marginTop: 2,
                      minWidth: { xs: 307, sm: 307, md: 407, lg: 407, xl: 407 },
                      marginRight: "auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Mui.Grid justifyContent="center">
                      <Mui.Button
                        variant="contained"
                        type="submit"
                        size="large"
                        sx={{
                          minWidth: {
                            xs: 340,
                            sm: 340,
                            md: 407,
                            lg: 407,
                            xl: 407,
                          },
                          borderRadius: 3,
                          backgroundColor: themes.loginImage,
                          "&:hover": {
                            border: "none",
                            background: themes.loginImage,
                          },
                          color: themes.whiteColor,
                          textTransform: "none",
                          fontSize: 20,
                        }}
                      >
                        {isLoading ? (
                          <Mui.CircularProgress size={24} color="inherit" />
                        ) : (
                          "Login"
                        )}
                      </Mui.Button>
                    </Mui.Grid>
                  </Mui.Grid>
                  <Mui.Grid container sx={{ paddingTop: 2 }}>
                    <Mui.Grid xs={1}>
                      <Info size="large" />
                    </Mui.Grid>
                    <Mui.Grid xs={11}>
                      <Mui.Stack direction="row">
                        <Mui.Typography
                          fontSize={15}
                          style={{ fontWeight: "bold" }}
                        >
                          First time login:
                        </Mui.Typography>{" "}
                        <Mui.Typography>
                          {" "}
                          If you are logging in for the
                        </Mui.Typography>
                      </Mui.Stack>
                      <Mui.Stack direction="row">
                        first time, click &nbsp;
                        <a
                          style={{ fontWeight: "bold" }}
                          href="/auth/send/otp"
                          onClick={() => {
                            localStorage.setItem(
                              "PasswordHandling",
                              "First Time Handle",
                            );
                          }}
                        >
                          here
                        </a>
                        &nbsp;to set password
                      </Mui.Stack>
                    </Mui.Grid>
                  </Mui.Grid>
                  <Mui.Grid container xs={12} sx={{ paddingTop: 2 }}></Mui.Grid>
                  <Mui.Grid
                    container
                    xs={12}
                    sx={{ paddingTop: 4, marginTop: 3 }}
                  >
                    <Mui.Grid
                      sx={{
                        borderRight: "3px solid green",
                      }}
                    ></Mui.Grid>
                    <Mui.Grid item xs={6}>
                      <a href="https://organflow.co/about.html">
                        <Mui.Typography
                          sx={{
                            fontWeight: 600,
                            borderRight: "3px solid green",
                            textAlign: "center",
                          }}
                        >
                          {" "}
                          About us
                        </Mui.Typography>
                      </a>
                    </Mui.Grid>
                    <Mui.Grid item xs={5.9}>
                      <a href="https://organflow.co/privacy-policy.html">
                        <Mui.Typography
                          sx={{
                            fontWeight: 600,
                            borderRight: "3px solid green",
                            textAlign: "center",
                          }}
                        >
                          Privacy Policy
                        </Mui.Typography>
                      </a>
                    </Mui.Grid>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
            </form>
          </Mui.Paper>
        </Mui.Grid>
      </Mui.Grid>
    </React.Fragment>
  );
};
